import { DialogActions, DialogTitle } from '@mui/material';
import { MemberCampaign } from '@retail/campaign/types';
import React from 'react';
import { useAppTFunction } from '@retail/app/i18n';
import { ContainedButton, Dialog, TextButton } from '@shared/components';

interface Props {
  campaign: MemberCampaign;
  onJoin: () => void;
  onClose: () => void;
  open: boolean;
  isLoading: boolean;
}

export const JoinCentralCampaignDialog = ({
  campaign,
  onJoin,
  onClose,
  open,
  isLoading,
}: Props) => {
  const t = useAppTFunction();
  return (
    <Dialog onClose={onClose} open={open}>
      <DialogTitle>{`${t('campaign.actions.joinCampaign')}: ${campaign.name}`}</DialogTitle>

      <DialogActions>
        <TextButton onClick={onClose} size="small">
          {t('common.cancel')}
        </TextButton>

        <ContainedButton loading={isLoading} onClick={onJoin} size="small">
          {t('campaign.actions.joinCampaignShort')}
        </ContainedButton>
      </DialogActions>
    </Dialog>
  );
};
